import AppConstants from '../../Constants/AppConstants';

const keyFor = provider =>
  `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:delivery:${provider}`;

export const readStuartEnvironmentDraft = () => {
  try {
    const value = JSON.parse(window.localStorage.getItem(keyFor('stuart')) || '{}');
    return ['Sandbox', 'Production'].includes(value?.selectedEnvironment)
      ? {selectedEnvironment: value.selectedEnvironment}
      : {};
  } catch (error) { return {}; }
};
export const writeStuartEnvironmentDraft = selectedEnvironment => {
  if (!['Sandbox', 'Production'].includes(selectedEnvironment)) return;
  try { window.localStorage.setItem(keyFor('stuart'), JSON.stringify({selectedEnvironment})); }
  catch (error) { /* Keep the integration form usable if storage is unavailable. */ }
};
export const clearStuartEnvironmentDraft = () => {
  try { window.localStorage.removeItem(keyFor('stuart')); }
  catch (error) { /* Ignore storage errors after save. */ }
};

const cleanCountries = rows => (Array.isArray(rows) ? rows : []).slice(0, 200).map(row => ({
  id: String(row?.id ?? '').slice(0, 80),
  country: String(row?.country ?? '').slice(0, 8),
  country_id: String(row?.country_id ?? '').slice(0, 40),
}));

export const readSendcloudCountryDraft = () => {
  try {
    const stored = window.localStorage.getItem(keyFor('sendcloud'));
    if (!stored) return null;
    const value = JSON.parse(stored);
    return {sendcloud_countries: cleanCountries(value?.sendcloud_countries)};
  } catch (error) { return {sendcloud_countries: []}; }
};
export const writeSendcloudCountryDraft = rows => {
  try { window.localStorage.setItem(keyFor('sendcloud'), JSON.stringify({sendcloud_countries: cleanCountries(rows)})); }
  catch (error) { /* Keep the integration form usable if storage is unavailable. */ }
};
export const clearSendcloudCountryDraft = () => {
  try { window.localStorage.removeItem(keyFor('sendcloud')); }
  catch (error) { /* Ignore storage errors after save. */ }
};
